<template>
  <AppSmartList
    ref="app-smart-list"
    :newRecord="{ show: this.newRecordsBtn }"
    :breadcrumbData="breadcrumbData"
    :accessRights="accessRights"
    :filters="filters"
    :actions="actions"
    :tableHeaders="headers"
  >
  </AppSmartList>
</template>

<script>
import AppSmartList from "@/views/components/bases/smart/AppSmartList.vue";
import commonMixin from "@/core/mixins/common.mixin";
import { i18nHelper } from "@/core/utils";
import { ROUTE_NAME } from "@/core/constants";
import {
  ROLE_PERMISSION_GET_PERMISSIONS,
  ROLE_PERMISSION_DELETE_PERMISSION,
  ROLE_PERMISSION_INITIAL_GET_PERMISSIONS_STATE,
  ROLE_PERMISSION_INITIAL_DELETE_PERMISSION_STATE,
} from "@/core/store/role-permission.module";
import { jwtHelper } from "@/core/utils";

export default {
  name: "rolepermissionlists",
  components: {
    AppSmartList,
  },
  mixins: [commonMixin],
  data: () => ({
    breadcrumbData: {
      breadcrumbs: [
        {
          title: i18nHelper.getMessage("label.rolePermission"),
          route: { name: ROUTE_NAME.ROLE_PERMISSION },
        },
      ],
    },
    actions: {
      // viewList: {
      //   module: "rolePermission",
      //   state: "permissions",
      //   action: ROLE_PERMISSION_GET_PERMISSIONS,
      //   initialStateAction: ROLE_PERMISSION_INITIAL_GET_PERMISSIONS_STATE,
      //   title: i18nHelper.getMessage("label.getApps"),
      // },
      // deleteRecord: {
      //   module: "rolePermission",
      //   state: "deletePermission",
      //   title: i18nHelper.getMessage("label.rolePermission"),
      //   message: i18nHelper.getMessage("message.requestDeleteMessage", [
      //     i18nHelper.getMessage("label.rolePermission"),
      //   ]),
      //   action: ROLE_PERMISSION_DELETE_PERMISSION,
      //   initialAction: ROLE_PERMISSION_INITIAL_DELETE_PERMISSION_STATE,
      //   successAction: () => {
      //     this.getList();
      //   },
      // },
    },
    newRecordsBtn: false,
    accessRights: {},
    filters: [
      {
        label: "roleName",
        key: "roleName",
      },
    ],
    headers: [
      {
        key: "roleName",
        name: "roleName",
      },
      {
        key: "adGroupName",
        name: "adGroupName",
      },
      {
        key: "status",
        name: "status",
        layout: "PermissionStatusLabel",
      },
      {
        key: "createdAt",
        name: "createdAt",
      },
      {
        key: "action",
        name: "action",
        active: true,
        layout: "AppTableActions",
        headersClass: "flex-text-center",
        layoutActions: {
          isShowDeleteButton: true,
          viewDetailsRouteName: ROUTE_NAME.ROLE_PERMISSION_DETAILS,
        },
      },
    ],
  }),
  created() {
    this.initialAction();
    this.checkcreatedbtn();
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    checkcreatedbtn() {
      let profile = jwtHelper.getProfile();
      let permissions = profile.permission.modules;
      let permissionRight = false;

      permissions.forEach(function (p) {
        if (p == "permissions_add") {
          permissionRight = true;
        }
      });

      this.newRecordsBtn = permissionRight;
    },
    initialAction() {
      this.actions = {
        viewList: {
          module: "rolePermission",
          state: "permissions",
          action: ROLE_PERMISSION_GET_PERMISSIONS,
          initialStateAction: ROLE_PERMISSION_INITIAL_GET_PERMISSIONS_STATE,
          title: i18nHelper.getMessage("label.getApps"),
        },
        deleteRecord: {
          module: "rolePermission",
          state: "deletePermission",
          title: i18nHelper.getMessage("label.rolePermission"),
          message: i18nHelper.getMessage("message.requestDeleteMessage", [
            i18nHelper.getMessage("label.rolePermission"),
          ]),
          action: ROLE_PERMISSION_DELETE_PERMISSION,
          initialAction: ROLE_PERMISSION_INITIAL_DELETE_PERMISSION_STATE,
          successAction: () => {
            this.getList();
          },
        },
      };
    },
    getList() {
      this.$refs["app-smart-list"].actionSearch();
    },
  },
};
</script>

<style></style>
